import { IAccountMappingSubFLI, IAccountMappingTemplateGroupItemFLI } from '@modeso/types__aumico-lib-annualreport-be';
import { ISplitAccountValues } from './split-account-values.interface';

export interface ISwitchAccountsData {
    accountNumber: string;
    accountName: string;
    currentValue: number;
    previousValue: number;
    parentOptions: (IAccountMappingTemplateGroupItemFLI | IAccountMappingSubFLI)[];
    splitAccountValues: ISplitAccountValues;
}
